import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconQuestionMark24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconQuestionMark24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.726 6.447c.182-.704.538-1.377 1.09-1.87.539-.481 1.306-.827 2.394-.827 1.094 0 1.82.347 2.281.868.474.535.759 1.355.759 2.456 0 1.067-.734 1.867-1.785 2.938l-.08.08c-.938.954-2.135 2.172-2.135 3.908a.75.75 0 0 0 1.5 0c0-1.066.733-1.867 1.785-2.937l.08-.081c.938-.954 2.135-2.172 2.135-3.908 0-1.343-.347-2.56-1.136-3.45-.802-.906-1.971-1.374-3.404-1.374-1.437 0-2.565.469-3.394 1.21C8 4.19 7.513 5.145 7.274 6.071a.75.75 0 0 0 1.452.375M12 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconQuestionMark24);
